import pubsub from "@viewlift/pubsub"
import Cookies from 'js-cookie'
import { debounce, setToken } from "./constant";
import { getDeviceId, handleStatusGaCalls } from "../../../helpers";
import { updateAuthorisationStore } from "./authStore";
import { ANALYTICSEVENTS } from "./analyticsMap";
import trackEvent from "../../../helpers/trackAnalytics.ts";
import { callRequest } from "../../../Graphql/request";
import { ANALYTICS, FB_EVENTS } from "../../../helpers/analyticsMap";
import { pushStepToFlow, triggerUserMergeEvent } from "../../helper";
import { publishUserCreated } from "../../Events/utils.events";

export const initApple = (actionType) => {
  const appleClientId = window?.app_data?.appcmsMain?.socialMedia?.appleSignin?.clientId
  window?.AppleID?.auth?.init({
    clientId: appleClientId, //make this dynamic
    scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
    redirectURI: `${window?.location?.origin}`, // As registered along with our service ID
    state: "origin:web", // Any string of your choice that you may use for some logic. It's optional and you may omit it.
    usePopup: true, // Important if we want to capture the data apple sends on the client side.
  });
  document.addEventListener('AppleIDSignInOnSuccess', (event) => {
    //handle successful response
    let response = event.detail
    let signIn = debounce(appleLogin,500)
    signIn(response.authorization.id_token, response.authorization.code, actionType)

  });

  document.addEventListener("AppleIDSignInOnFailure", ({ detail = {} }) => {
    console.log(detail)
  })
};

const errorHandling = () => {
  pubsub.publish('user-analytics',{ename:ANALYTICS.LOGIN_FAILURE,data:{provider:'APPLE'}});
  console.log(err, 'error from apple Login')
  pubsub.publish('apploading',false)
  trackEvent(ANALYTICS.LOGIN_FAILURE, { provider: "APPLE", error: 'Error from apple Login' }, null)
}
let appleLogin = (token, code, actionType) => {
  pubsub.publish('apploading',true)

  let cb = () => console.log("cb")
  var deviceId = getDeviceId();
  let utmCookie = Cookies.get('utm')
  let utmData = utmCookie && JSON.parse(utmCookie)
  let variables = {
    "site": window?.app_data?.site?.siteInternalName,
    "device": "web_browser",
    "action": actionType ? "SIGNUP" : "SIGNIN",
    "input": {
      "identityToken": token,
      "emailConsent": true,
      "deviceId": deviceId,
      "campaign": (utmData && utmData.utm_campaign) || null,
      "campaignSource": (utmData && utmData.utm_source) || null,
      "campaignMedium": (utmData && utmData.utm_medium) || null,
      "deviceName": 'web_browser',
      "platform": "web_browser"
    }
  }
  trackEvent('login_init', { ...{method: "Apple"},  ...variables}, null)
  return callRequest({type : "appleValidate", variables,cb,errorHandling}).then( async (response) => {
    let res = response?.identitySignInApple
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
    let eventData = {
      "pageUrl": checkoutInitPageDetails?.pageUrl,
      "email" : res.email,
    }
    localStorage.setItem('deviceId',deviceId)
      await updateAuthorisationStore({ userdetails: res })
      pubsub.publish('apploading',false)
      pushStepToFlow("email added")
      if (res.isSubscribed) pubsub.publish("isAuthenticated", {...res,provider:'APPLE'})
        else pubsub.publish('isAuthenticated', { isSubscribed: false ,provider:'APPLE'})
      // if (res.isSubscribed) pubsub.publish("user", {...res,provider:'APPLE'})
      // else pubsub.publish('user', { isSubscribed: false ,provider:'APPLE'})
      let token = res && {
        authorizationToken: res.authorizationToken,
        refreshToken: res.refreshToken
      }
      setToken(token)
      if(res.existingUser) {
        eventData.loginVia = 'appleId'
        triggerUserMergeEvent(res.existingUser)
        let analyticsData={ename: ANALYTICSEVENTS.CHECKOUT_USER_LOGIN_SUCCESS, data: eventData};
        handleStatusGaCalls({eventName : 'checkout_user_login_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
        pubsub.publish('user-analytics',analyticsData)
      } else {
        eventData.registeredVia = 'appleId'
        triggerUserMergeEvent(res.existingUser)
        let analyticsData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_SUCCESS, data: eventData};
        handleStatusGaCalls({eventName : 'checkout_user_create_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Create Success', paymentStatus : null,eventCategory : 'Checkout'})
        pubsub.publish('user-analytics',analyticsData)
      } 
      publishUserCreated({status : true })
      return { type: 'LOGIN', payload: res }
  })
}

export const signInApple = async () => {
  window.AppleID.auth.signIn();
  trackEvent('login', { method: "Apple" },null)
  pubsub.publish('FB-analytics',{eventType : FB_EVENTS.LOGIN ,payload : {platform: 'Web', registrationType: 'Apple'},type : "FB"})
};